export default __webpack_public_path__ + "vision-external-camera-thumbnail-480-879b6fe462769d4b9f527b984e2e04eb.webp";